export const CREATE_DOCUMENT_MODAL = {
    CREATE_TEMPLATE_TITLE: { key: "CREATE_TEMPLATE_TITLE", value: 'Design a new document template' },
    CLONE_TEMPLATE_TITLE: { key: "CLONE_TEMPLATE_TITLE", value: 'Clone template' },   
    SIZE_DROPDOWN_OPTION_LABEL: { key: 'SIZE_DROPDOWN_OPTION_LABEL', value: "Size" },
    COMPLEX_PAGE_SIZE_DROPDOWN_OPTION_LABEL: { key: 'COMPLEX_PAGE_SIZE_DROPDOWN_OPTION_LABEL', value: "Default Page Size" },
    COMPLEX_PAGE_ORIENTATION_DROPDOWN_LABEL: { key: 'COMPLEX_PAGE_ORIENTATION_DROPDOWN_LABEL', value: "Default Page Orientation" },
    COMPLEX_DOCUMENT_SWITCH_LABEL: { key: 'COMPLEX_DOCUMENT_SWITCH_LABEL', value: "Complex Document" },
    CUSTOM_PAPER_SIZE_LABEL: { key: 'CUSTOM_PAPER_SIZE_LABEL', value: 'Custom' },
    CUSTOM_HEIGHT_LABEL: { key: 'CUSTOM_HEIGHT_LABEL', value: 'Height' },
    CUSTOM_WIDTH_LABEL: { key: 'CUSTOM_WIDTH_LABEL', value: 'Width' },
    SIZE_IN_LABEL: { key: 'SIZE_IN_LABEL', value: 'Size in' },
};

export const MAIL_TEMPLATE_MODAL = {
    CREATE_NEW_EMAIL_TEMPLATE_TITLE: { key: "CREATE_NEW_EMAIL_TEMPLATE_TITLE", value: 'Design a new email template' },
    CLONE_TEMPLATE_TITLE: { key: "CLONE_TEMPLATE_TITLE", value: 'Clone template' },
    FROM_MAIL_ADDRESS_LABEL: { key: 'FROM_MAIL_ADDRESS_LABEL', value: "From Mail address" },
    SELECT_MAIL_ADDRESS_PLACEHOLDER: { key: 'SELECT_MAIL_ADDRESS_PLACEHOLDER', value: "Select a mail address" },   
    TEMPLATE_ALREADY_EXIST_WARNING_MESSAGE: { key: "TEMPLATE_ALREADY_EXIST_WARNING_MESSAGE", value: 'Template name already exists, try different one!' },   
};

export const CREATE_NEW_TEMPLATE_MODAL = {
    TEMPLATE_NAME_LABEL: { key: 'TEMPLATE_NAME_LABEL', value: "Provide a unique name for your design" },
    TEMPLATE_NAME_PLACEHOLDER: { key: 'TEMPLATE_NAME_PLACEHOLDER', value: "Name your template" },
    SELECT_CATEGORY_LABEL: { key: 'SELECT_CATEGORY_LABEL', value: "Select a category for your design" },
    SELECT_CATEGORY_PLACEHOLDER: { key: 'SELECT_CATEGORY_PLACEHOLDER', value: "Select a category" }, 
    ADD_NEW_ACTION: { key: "ADD_NEW_ACTION", value: 'Add new' },
    CATEGORY_NAME_LABEL: { key: 'CATEGORY_NAME_LABEL', value: "Category Name" },
    CATEGORY_NAME_PLACEHOLDER: { key: 'CATEGORY_NAME_PLACEHOLDER', value: "Name your category" },   
    SELECT_TEAM_LABEL: { key: "SELECT_TEAM_LABEL", value: 'Select a team for your design' },
    SELECT_TEAM_PLACEHOLDER: { key: "SELECT_TEAM_PLACEHOLDER", value: 'Select a team' },
    CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
    SAVE_BUTTON: { key: 'SAVE_BUTTON', value: 'Save' },
    START_DESIGN_BUTTON: { key: 'START_BUTTON', value: 'Start designing' },
    SAVING_CATEGORY_LOADING_TEXT: { key: 'SAVING_CATEGORY_LOADING_TEXT', value: 'Saving' },
    ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE: { key: "ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE", value: 'Please enter a valid template name' },
    MASTER_TEMPLATE_DESC: { key: "MASTER_TEMPLATE_DESC", value: 'This helps you get started with already designed templates' },
    CLICK_TO_SELECT_BUTTON: { key: "CLICK_TO_SELECT_BUTTON", value: 'Click To Select A Design' },
    FREE_PLAN_UPGRADE_MESSAGE: { 
        key: 'FREE_PLAN_UPGRADE_MESSAGE',
        value: 'In your free plan, you are limited to creating just {{documentLimit}} documents. To create more documents, please upgrade your plan.' },
    STANDARD_PLAN_UPGRADE_MESSAGE: { 
        key: 'STANDARD_PLAN_UPGRADE_MESSAGE', 
        value: 'In your standard plan, you are limited to creating just {{documentLimit}} documents. To create more documents, please upgrade your plan.' },
    PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED: {
        key: 'PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED', 
        value: "You have reached the limit for document creation under your current plan. To create more documents, you can upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>."
    },
    CHAR_LIMIT_EXCEEDED_ERROR: { key: 'CHAR_LIMIT_EXCEEDED_ERROR', value: 'Maximum of {{charLimitLength}} characters allowed' },
    ENABLE_AUTO_GENERATE_HELP_TEXT: { key: 'ENABLE_AUTO_GENERATE_HELP_TEXT' , value: 'Enable this option to auto-generate your email from the document content.'},
    SELECT_FLOWS_HELP_TEXT: { key: 'CHECK_FLOW_HELP_TEXT', value: 'Select the necessary content displayed on the right from this document to proceed.'},
    AUTO_GENERATE_EMAIL : { key: 'AUTO_GENERATE_EMAIL' , value: 'Auto generate email from this document'},
    UNABLE_To_CREATE_TEMPLATE : { key: 'UNABLE_To_CREATE_TEMPLATE' , value: 'An error occurred while creating the {{type}}. Please try again.'},
    COMMUNICATION_NAME_VALIDATION : { key: 'COMMUNICATION_NAME_VALIDATION' , value: 'Communication name already exists'},
    COMMUNICATION_NAME_UNSUPPORTED_CHARS: {
        key: 'COMMUNICATION_NAME_UNSUPPORTED_CHARS',
        value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
    },
};

export const CREATE_NEW_BLOCK_MODAL = {
    BLOCK_NAME_LABEL: { key: 'BLOCK_NAME_LABEL', value: "Provide a unique name for your design" },
    BLOCK_NAME_PLACEHOLDER: { key: 'BLOCK_NAME_PLACEHOLDER', value: "Name your template" },
    SELECT_CATEGORY_LABEL: { key: 'SELECT_CATEGORY_LABEL', value: "Select a category for your design" },
    SELECT_CATEGORY_PLACEHOLDER: { key: 'SELECT_CATEGORY_PLACEHOLDER', value: "Select a category" }, 
    ADD_NEW_ACTION: { key: "ADD_NEW_ACTION", value: 'Add new' },
    CATEGORY_NAME_LABEL: { key: 'CATEGORY_NAME_LABEL', value: "Category Name" },
    CATEGORY_NAME_PLACEHOLDER: { key: 'CATEGORY_NAME_PLACEHOLDER', value: "Name your category" },   
    SELECT_TEAM_LABEL: { key: "SELECT_TEAM_LABEL", value: 'Select a team for your design' },
    SELECT_TEAM_PLACEHOLDER: { key: "SELECT_TEAM_PLACEHOLDER", value: 'Select a team' },
    CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
    SAVE_BUTTON: { key: 'SAVE_BUTTON', value: 'Save' },
    START_DESIGN_BUTTON: { key: 'START_BUTTON', value: 'Start designing' },
    SAVING_CATEGORY_LOADING_TEXT: { key: 'SAVING_CATEGORY_LOADING_TEXT', value: 'Saving' },
    ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE: { key: "ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE", value: 'Please enter a valid template name' },
    CREATE_BUTTON: { key: 'CREATE_BUTTON', value: 'Create' },
    ENTER_VALID_NAME_ERROR_MESSAGE: { key: "ENTER_VALID_NAME_ERROR_MESSAGE", value: 'Please enter a valid template name' },
    SECTION_CREATION_ERROR_MESSAGE: { key: "CREATE_REUSABLE_SECTION_TITLE", value: 'An error occurred during the creation of a new reusable section' }, 
    SELECT_BLOCK_TYPE_LABEL: { key: 'SELECT_BLOCK_TYPE_LABEL', value: 'Select a block type' },
    HEADER_OPTION: { key: 'HEADER_OPTION', value: 'Header' },
    FOOTER_OPTION: { key: 'FOOTER_OPTION', value: 'Footer' },
    CONTENT_OPTION: { key: 'CONTENT_OPTION', value: 'Content' },
    CHAR_LIMIT_EXCEEDED_ERROR: { key: 'CHAR_LIMIT_EXCEEDED_ERROR', value: 'Maximum of {{charLimitLength}} characters allowed' },
    SECTION_NAME_UNSUPPORTED_CHARS: {
        key: 'SECTION_NAME_UNSUPPORTED_CHARS',
        value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
    },
};

export const CREATE_NEW_FLOW_MODAL = {
    FLOW_NAME_LABEL: { key: 'FLOW_NAME_LABEL', value: "Provide a unique name for your design" },
    FLOW_NAME_PLACEHOLDER: { key: 'FLOW_NAME_PLACEHOLDER', value: "Name your reusable page" },
    SELECT_CATEGORY_LABEL: { key: 'SELECT_CATEGORY_LABEL', value: "Select a category for your design" },
    SELECT_CATEGORY_PLACEHOLDER: { key: 'SELECT_CATEGORY_PLACEHOLDER', value: "Select a category" }, 
    ADD_NEW_ACTION: { key: "ADD_NEW_ACTION", value: 'Add new' },
    CATEGORY_NAME_LABEL: { key: 'CATEGORY_NAME_LABEL', value: "Category Name" },
    CATEGORY_NAME_PLACEHOLDER: { key: 'CATEGORY_NAME_PLACEHOLDER', value: "Name your category" },   
    SELECT_TEAM_LABEL: { key: "SELECT_TEAM_LABEL", value: 'Select a team for your design' },
    SELECT_TEAM_PLACEHOLDER: { key: "SELECT_TEAM_PLACEHOLDER", value: 'Select a team' },
    CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
    SAVE_BUTTON: { key: 'SAVE_BUTTON', value: 'Save' },
    START_DESIGN_BUTTON: { key: 'START_BUTTON', value: 'Start designing' },
    SAVING_CATEGORY_LOADING_TEXT: { key: 'SAVING_CATEGORY_LOADING_TEXT', value: 'Saving' },
    ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE: { key: "ENTER_VALID_TEMPLATE_NAME_WARNING_MESSAGE", value: 'Please enter a valid reusable page name' },
    CREATE_BUTTON: { key: 'CREATE_BUTTON', value: 'Create' },
    COMPLEX_PAGE_SIZE_DROPDOWN_OPTION_LABEL: { key: 'COMPLEX_PAGE_SIZE_DROPDOWN_OPTION_LABEL', value: "Default Page Size" },
    CUSTOM_PAPER_SIZE_LABEL: { key: 'CUSTOM_PAPER_SIZE_LABEL', value: 'Custom' },
    CUSTOM_HEIGHT_LABEL: { key: 'CUSTOM_HEIGHT_LABEL', value: 'Height' },
    CUSTOM_WIDTH_LABEL: { key: 'CUSTOM_WIDTH_LABEL', value: 'Width' },
    SIZE_IN_LABEL: { key: 'SIZE_IN_LABEL', value: 'Size in' },
    CREATEION_NEW_PAGE_ERROR_MESSAGE:{ key: 'ERROR_MESSAGE', value: 'An error occurred during the creation of a new page.' },
    PAGE_NAME_ALREADY_EXIST_ERROR_MESSAGE:{ key: 'PAGE_NAME_ALREADY_EXIST_ERROR_MESSAGE', value: 'This name is already in use for reusable pages. Please provide a different and unique name.' },
    NEW_PAGE_CREATED_SUCCESS_MESSAGE: { key: 'NEW_PAGE_CREATED_SUCCESS_MESSAGE', value: 'New page has been created successfully' },
    ENTER_VALID_NAME_ERROR_MESSAGE: { key: "ENTER_VALID_NAME_ERROR_MESSAGE", value: 'Please enter a valid template name' },
    CHAR_LIMIT_EXCEEDED_ERROR: { key: 'CHAR_LIMIT_EXCEEDED_ERROR', value: 'Maximum of {{charLimitLength}} characters allowed' },
    PAGE_NAME_UNSUPPORTED_CHARS: {
        key: 'PAGE_NAME_UNSUPPORTED_CHARS',
        value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
    },
};

export const CREATE_FLOW_MODAL = {
    CREATE_REUSABLE_PAGE_TITLE: { key: "CREATE_REUSABLE_PAGE_TITLE", value: 'Design a new reusable page' },
};

export const CREATE_BLOCK_MODAL = {
  CREATE_REUSABLE_SECTION_TITLE: {
    key: 'CREATE_REUSABLE_SECTION_TITLE',
    value: 'Design a new reusable section',
  },
  LANGUAGE_LABEL: { key: 'LANGUAGE_LABEL', value: 'Language' },
};
